export default class OrderError extends Error {
  errors: any
  refCode: any

  constructor(message: string) {
    super(message)
    this.name = 'OrderError'
  }
}
